import { useCallback } from "react";

export default function useUploadSignature() {
  const uploadSignature = useCallback(async (blob: Blob, token: string) => {
    const formData = new FormData();

    formData.append("file", blob);

    const apiUrl = `${import.meta.env.VITE_SCREENSHOT_URL}/v1/screenshot/document/signature`;

    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("response error:", response.status, errorText);
      return false;
    }

    console.log("response ok:", response.status);
    return true;
  }, []);

  return { uploadSignature };
}
